export default "__VITE_ASSET__CsZDGjY___"